import React from 'react';

const BS_JS_Carousel = () => {
    return (
        <div>
            <h1>BS_JS_Carousel Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_JS_Carousel;
